import React from 'react';

const e = React.createElement;


function PageNotFound() {}
PageNotFound.prototype = Object.create(React.Component.prototype);

PageNotFound.prototype.render = function() {
  var text_404 = "Pagina niet gevonden.";
  if(this.props.lang === "EN") {
    text_404 = "Page not found.";
  }
  var text_path1 = "De inhoud voor ";
  var text_path2 = " is niet gevonden. De pagina bestaat niet of is verplaatst, of de link bevat een typefout. Probeer om terug te gaan naar de vorige pagina of de hoofdpagina.";
  if(this.props.lang === "EN") {
    text_path1 = "The content for ";
    text_path2 = " could not be found. The page does not exist or has been moved, or the link has a typo. Try going back to the previous page or the homepage.";
  }
  var text_back = "Ga naar de hoofdpagina";
  if(this.props.website) {
    text_back = "Ga naar de hoofdpagina van "+this.props.website;
  }
  if(this.props.lang === "EN") {
    text_back = "Go to the homepage";
    if(this.props.website) {
      text_back = "Go to the homepage of "+this.props.website;
    }
  }

  return e('div', {style:{"padding":"14px", maxWidth:"500px", textAlign:"center", margin:"0 auto"}}, [
    e('h1', {key:"1"}, text_404),
    e('p', {key:"2"}, [
      text_path1,
      e('b', {key:"21"}, this.props.location.pathname),
      text_path2,
    ]),
    e('a', {key:"3", href:"/", className:"btn btn-b"}, text_back),
  ]);
}


export default PageNotFound



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/PageNotFound.js
// module id = 199
// module chunks = 0